import { useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { api, formatApiErrorDetail, API_BASE } from "@/lib/api";
import PasswordInput from "@/components/PasswordInput";

export default function ResetPassword() {
  const { token } = useParams();
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [done, setDone] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setErr("");
    if (pw !== pw2) { setErr("Passwords do not match."); return; }
    if (pw.length < 8) { setErr("Password must be at least 8 characters."); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      setDone(true);
      setTimeout(() => nav("/login"), 2500);
    } catch (e) { setErr(formatApiErrorDetail(e.response?.data?.detail) || e.message); }
    finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-slate-100">
      <form onSubmit={submit} className="w-full max-w-md bg-white p-8 rounded-md border border-slate-200" data-testid="reset-form">
        <div className="flex flex-col items-center mb-6">
          <img src={`${API_BASE}/settings/company/logo`} alt="SOS" className="h-14 w-14 rounded-md object-contain" />
          <div className="font-black text-xl mt-2">Safety Onsite Solutions</div>
        </div>
        <div className="tinylabel">Password</div>
        <h1 className="text-3xl font-black mt-1">Set a new password</h1>
        {done ? (
          <div data-testid="reset-success" className="mt-4 text-sm text-emerald-700 bg-emerald-50 border border-emerald-200 rounded p-3">
            Password updated. Redirecting you to sign in…
          </div>
        ) : (
          <>
            <label className="block text-sm font-semibold text-slate-700 mt-6">New password</label>
            <PasswordInput required value={pw} onChange={(e) => setPw(e.target.value)}
                   data-testid="reset-password" autoComplete="new-password" wrapperClassName="mt-1"
                   className="w-full h-12 px-3 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500" />
            <label className="block text-sm font-semibold text-slate-700 mt-4">Confirm new password</label>
            <PasswordInput required value={pw2} onChange={(e) => setPw2(e.target.value)}
                   data-testid="reset-password-confirm" autoComplete="new-password" wrapperClassName="mt-1"
                   className="w-full h-12 px-3 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500" />
            {err && <div className="mt-3 text-sm text-red-600">{err}</div>}
            <button data-testid="reset-submit" disabled={busy}
                    className="mt-6 w-full h-12 bg-green-600 hover:bg-green-700 text-white font-bold rounded-md disabled:opacity-60">
              {busy ? "Updating…" : "Update password"}
            </button>
          </>
        )}
        <div className="mt-4 text-sm text-center">
          <Link to="/login" className="text-green-700 font-semibold">Back to sign in</Link>
        </div>
      </form>
    </div>
  );
}
